import Rails from '@rails/ujs';

// Base
import '../init/out';
import '../controllers';
import application from '../controllers/application';
import SliderController from '../controllers/slider_controller';
import { followPreferenceOnHistoryRestore } from '../lib/theme';

// Styled Components
import '../components/faq-vote/faq-vote';
import '../components/form/form';
import '../components/flashes/flashes';
import '../components/navbar/navbar';

// Enregistré ici et non dans controllers/index.ts : tiny-slider entrerait
// sinon dans le chunk que in.js partage, pour la seule home.
application.register('slider', SliderController);

// Une page ouverte par l'app garde le thème que l'app lui impose (ThemeHelper) :
// elle ne se réaligne pas sur le cookie.
if (!new URLSearchParams(window.location.search).has('appLinkingUri')) {
  followPreferenceOnHistoryRestore();
}

// Hack avec vite: auto loadé en prod, mais pas en dev
// eslint-disable-next-line
if (!window._rails_loaded) {
  Rails.start(); // Turbo methods
}
